/*
 * @Author: liyihui
 * @Date:
 * @description: 登录后根据权限，修改路由和菜单表
 * @Last Modified by:
 * @Last Modified time:
 */
import router from '@/router';
import { routerMap } from '@/router';
import store from '@/store';

// res_nm: "zyb-1-2"
// sdesc: "企业管理1"
// user_id: "1e6e942f-0635-426b-a4fb-0069b8af324f"

/**
 * 根据权限表加载路由菜单
 * 特殊情况需要全权限时，accessedRouter = routerMap;
 */
export function initRouterList() {
	//  store中的的权限表
	const roles = store.getters.roles;

	// let accessedRouter = [];
	let accessedRouter = accessedRouter = routerMap;
	// 赋值为 权限过滤后的router文件的路由表
	accessedRouter = filterRouter(routerMap, roles);
	// store赋值加载权限后的路由 给左菜单组件使用
	store.commit('SET_MENULIST', accessedRouter);

	// 给router路由本体赋值
	router.addRoutes(accessedRouter);
}

/**
 * 递归过滤路由表，返回符合用户角色权限的路由表
 * @param routes 路由表
 * @param roles 权限表
 */
 function filterRouter(routes, roles) {
	const accessedRouter = [];
	routes.forEach(route => {
		const routeItem = { ...route };
		if (hasPermission(roles, routeItem)) {
			if (routeItem.children) {
				routeItem.children = filterRouter(routeItem.children, roles);
			}
			accessedRouter.push(routeItem);
		}
	});
	return accessedRouter;
}

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles 权限表
 * @param route 某一个路由项
 */
 function hasPermission(roles, route) {
	if (route.meta && route.meta.roles) {
		// 如果权限表roles中某一个符合 => 被路由中的roles包含 => 返回true 否则false
		return roles.some(role => route.meta.roles.includes(role.res_nm));
	} else {
		return true;
	}
}



// WEBPACK FOOTER //
// ./src/utils/permission.js